import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { METHOD_PAGE } from "../data/content";
import ContactSplit from "../components/sections/ContactSplit";
import { MaskedLine, MaskedLineInView } from "../components/MaskedLine";

const GROUNDS = ["ground-highlighter", "ground-lab", "ground-margin"];

export default function HowWeDesignPage() {
  return (
    <main data-testid="page-how-we-design">
      {/* Hero */}
      <section className="ground-paper pt-[104px] pb-14 md:pt-[132px] md:pb-20">
        <div className="wrap">
          <div className="flex items-center gap-4 mb-12">
            <span className="series-stamp"><span>Method</span></span>
            <span className="stamp-dim">SAM · LTEM · Phillips ROI</span>
          </div>
          <h1 className="h-hero max-w-[1200px]" style={{ fontSize: "clamp(48px, 8vw, 128px)" }} data-testid="method-title">
            <MaskedLine>How we</MaskedLine>{" "}
            <MaskedLine delay={0.12}><span className="claim">design.</span></MaskedLine>
          </h1>
          <p className="aside mt-10 max-w-[760px]">{METHOD_PAGE.intro}</p>
        </div>
      </section>

      {/* Frameworks */}
      {METHOD_PAGE.frameworks.map((f, i) => (
        <section
          key={f.abbr}
          data-testid={`method-framework-${f.abbr.toLowerCase().replace(/\s+/g, "-")}`}
          className={`${GROUNDS[i]} sec-pad border-t-[1.5px] border-[color:var(--ink)]`}
        >
          <div className="wrap grid lg:grid-cols-12 gap-x-10 gap-y-12">
            <div className="lg:col-span-4">
              <span className="series-stamp"><span>{f.n} · {f.use}</span></span>
              <h2 className="h-section mt-8" style={{ fontSize: "clamp(40px, 5vw, 72px)" }}>
                <MaskedLineInView>{f.abbr}</MaskedLineInView>
              </h2>
              <p className="stamp-dim mt-4">{f.name}</p>
            </div>
            <div className="lg:col-span-8">
              <p className="font-aside" style={{ fontSize: "clamp(21px, 2vw, 27px)", lineHeight: 1.45 }}>
                {f.body}
              </p>
              <ol className="mt-10 border-t-[1.5px] border-[color:var(--ink)]">
                {f.points.map((pt, j) => (
                  <li key={j} data-testid={`method-point-${i}-${j}`} className="grid grid-cols-[auto_1fr] gap-x-8 py-6 border-b-[1.5px] border-[color:var(--ink)]">
                    <span className="font-mono font-semibold text-[color:var(--signal)] pt-1" style={{ fontSize: 12, letterSpacing: "0.14em" }}>
                      0{j + 1}
                    </span>
                    <p className="font-body-serif" style={{ fontSize: 17, lineHeight: 1.6 }}>{pt}</p>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </section>
      ))}

      {/* Closing standard */}
      <section className="ground-ink text-[color:var(--paper)] sec-pad" data-testid="method-closing">
        <div className="wrap max-w-[900px]">
          <span className="series-stamp on-ink"><span>The standard</span></span>
          <p className="h-tile mt-10" style={{ fontSize: "clamp(28px, 3.6vw, 52px)", lineHeight: 1.1 }}>
            &ldquo;{METHOD_PAGE.closing}&rdquo;
          </p>
          <Link to="/contact" className="btn-outline on-ink mt-12 inline-flex items-center gap-2" data-testid="method-cta">
            Discuss a programme <ArrowUpRight size={14} />
          </Link>
        </div>
      </section>

      <ContactSplit />
    </main>
  );
}
